export const ActivityState = {
	created: "created",
	running: "running",
	completed: "completed",
	error: "error",
	stopped: "stopped",
	unspecified: "unspecified",
} as const;
